import React, { useState } from 'react';
import './index.css';
import { Form, InputGroup, Button } from 'react-bootstrap';
import { IoMdAdd, IoMdCheckmark } from 'react-icons/io';
import { IoClose, IoCreate } from 'react-icons/io5';
import { toast } from 'react-toastify';

function PaymentForm({ paymentPlanData, setPaymentPlanData }) {

  const [index, setIndex] = useState(null);
  const [data, setData] = useState({
    serialNumber: '',
    name: '',
    value: '',
    other: '',
    isCompleted: false,
    valueType: 'percent',
    description: ''
  });
  const [inputError, setInputError] = useState(null);

  function handleChange(e) {
    const { id, value } = e.target;
    setInputError({ ...inputError, [id]: '' });
    setData((prevData) => {
      return { ...prevData, [id]: value };
    });
  }

  function handleData() {
    let totalPlanPercentage = paymentPlanData ? paymentPlanData.reduce((x, a) => parseFloat(x) + parseFloat(a.value), 0) : 0;
    totalPlanPercentage = parseFloat(totalPlanPercentage) + parseFloat(data.value ? data.value : 0);
    let totalPlanOtherPercentage = paymentPlanData ? paymentPlanData.reduce((x, a) => parseFloat(x) + parseFloat(a.other), 0) : 0;
    console.log('--> ', totalPlanOtherPercentage);
    totalPlanOtherPercentage = parseFloat(totalPlanOtherPercentage) + parseFloat(data.other ? data.other : 0);
    console.log(totalPlanOtherPercentage);

    if (data && !data.name) {
      setInputError({ ...inputError, name: 'This field is required.' });
    } else if (data && !data.value) {
      setInputError({ ...inputError, value: 'This field is required.' });
    } else if (totalPlanPercentage > 100) {
      toast.error('Total Basic Price not more than 100%.');
    } else if (totalPlanOtherPercentage > 100) {
      toast.error('Total Additional Charges not more than 100%.');
    } else {
      var tempData = paymentPlanData ? paymentPlanData : [];
      var serialNumber = tempData.length + 1;
      tempData.push({ ...data, serialNumber: serialNumber });
      setData({ serialNumber: '', name: '', value: '', other: '', isCompleted: false, valueType: 'percent', description: '' });
      setPaymentPlanData(tempData);
    }
  }

  function handleDeleteData(index) {
    let tempData = paymentPlanData;
    tempData.splice(index, 1);
    setPaymentPlanData(tempData);
    setData({ serialNumber: '', name: '', value: '', other: '', isCompleted: false, valueType: 'percent', description: '' });
    setIndex(null);
  }

  return (
    <div id="content" style={{ maxHeight: 360, overflow: 'hidden', overflowY: 'scroll' }}>
      <ul className="timeline">
        {
          paymentPlanData && paymentPlanData.map((item, index) => {
            return (
              <div key={index} className='row mb-3'>
                <div className='col-md-10'>
                  <li className="event border border-primary-light rounded p-3">
                    <div className='d-flex align-items-start justify-content-between'>
                      <h6 className='mb-0 fw-normal'>{item.name}</h6>
                      <div className='text-end'>
                        <h6 className='mb-0 fw-normal'>{item.value}{item.valueType === 'percent' ? '% of Basic Price' : ''}</h6>
                        {item.other && parseFloat(item.other) > 0 ? <h6 className='mb-0 fw-normal'><small>+ {item.other}{item.valueType === 'percent' ? '% of Addtional Charges' : ''}</small></h6> : null}
                      </div>
                    </div>
                    <p className='mb-0 fw-light text-muted'>
                      <small>{item.description}</small>
                    </p>
                  </li>
                </div>
                <div className='col-md-2 d-flex align-items-center'>
                  <div className='d-flex align-items-center'>
                    <Button
                      variant='light'
                      className='p-2 mx-2 rounded-circle'
                    >
                      <IoCreate size={20} color='var(--bs-primary)' />
                    </Button>
                    <Button
                      variant='light'
                      className='p-2 mx-2 rounded-circle'
                      onClick={() => handleDeleteData(index)}
                    >
                      <IoClose size={20} color='var(--bs-danger)' />
                    </Button>
                  </div>
                </div>
              </div>
            )
          })
        }
        <li className="border border-primary-light bg-light rounded p-3">
          <div className='row'>
            <div className='col-md-12 col-12'>
              <Form.Group className="mb-3" controlId="name">
                <Form.Label>Name of Payment *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter payment name"
                  className={inputError && inputError.name ? 'border-danger' : null}
                  onChange={handleChange}
                  value={data && data.name}
                  isInvalid={inputError && inputError.name}
                />
                <Form.Control.Feedback type="invalid">{inputError && inputError.name}</Form.Control.Feedback>
              </Form.Group>
            </div>
            <div className='col-md-12 col-12'>
              <div className='d-flex justify-content-between'>
                <Form.Group className="mb-3 w-100">
                  <Form.Label>Basic Price (%)</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type="number"
                      placeholder="0"
                      className={inputError && inputError.value ? 'border-right-0 border-danger' : 'border-right-0'}
                      onChange={(event) => {
                        setInputError({ ...inputError, value: '' });
                        setData((prevData) => {
                          return { ...prevData, value: event.target.value };
                        });
                      }}
                      value={data && data.value}
                      isInvalid={inputError && inputError.value}
                    />
                    <InputGroup.Text><small>{data && data.valueType === 'percent' ? '% of Basic Price' : ''}</small></InputGroup.Text>
                    <Form.Control
                      type="number"
                      placeholder="0 (optional)"
                      className="border-right-0 border-left-0"
                      onChange={(event) => {
                        setData((prevData) => {
                          return { ...prevData, other: event.target.value };
                        });
                      }}
                      value={data && data.other}
                    />
                    <InputGroup.Text className='rounded-end'><small>{data && data.valueType === 'percent' ? '% of Additional Charges' : ''}</small></InputGroup.Text>
                    <Form.Control.Feedback type="invalid">{inputError && inputError.value}</Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
              </div>
            </div>
            <div className='col-md-9 col-12'>
              <Form.Group controlId="description">
                <Form.Label>Short Description (Optional)</Form.Label>
                <Form.Control
                  as='textarea'
                  rows={1}
                  placeholder="Enter short description"
                  onChange={handleChange}
                  value={data && data.description}
                />
              </Form.Group>
            </div>
            <div className='col-md-3 col-12'>
              <div className='h-100 d-flex align-items-end justify-content-end'>
                {
                  data && index !== null ?
                    <Button
                      variant='warning'
                      onClick={handleData}
                      className='py-1 w-100'
                    >
                      <div className='py-1'>
                        <IoMdCheckmark size={20} />
                        <span className='ms-1'>Update</span>
                      </div>
                    </Button>
                    :
                    <Button
                      variant='success'
                      onClick={handleData}
                      className='py-1 px-0 w-100'
                    >
                      <div className='py-1 d-flex align-items-center justify-content-center'>
                        <IoMdAdd size={18} />
                        <span className='ms-1'>Add</span>
                      </div>
                    </Button>
                }
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
}

export default PaymentForm;
